function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-502.86 -41.014)",
  fill: "#000"
}, /*#__PURE__*/React.createElement("path", {
  id: "XMLID_1775_",
  d: "m358.9 351.1v-6c0-2.3-1.4-3.8-3.8-3.8-1.2 0-2.5 0.4-3.4 1.7-0.7-1.1-1.7-1.7-3.2-1.7-1 0-2 0.3-2.8 1.4v-1.2h-2.1v9.6h2.1v-5.3c0-1.7 0.9-2.5 2.3-2.5s2.1 0.9 2.1 2.5v5.3h2.1v-5.3c0-1.7 1-2.5 2.3-2.5 1.4 0 2.1 0.9 2.1 2.5v5.3zm31.1-9.6h-3.4v-2.9h-2.1v2.9h-1.9v1.9h1.9v4.4c0 2.2 0.9 3.5 3.3 3.5 0.9 0 1.9-0.3 2.6-0.7l-0.6-1.8c-0.6 0.4-1.3 0.5-1.8 0.5-1 0-1.4-0.6-1.4-1.6v-4.3h3.4zm17.8-0.2c-1.2 0-2 0.6-2.5 1.4v-1.2h-2.1v9.6h2.1v-5.4c0-1.6 0.7-2.5 2-2.5 0.4 0 0.9 0.1 1.3 0.2l0.6-2c-0.4-0.1-1-0.1-1.4-0.1zm-26.9 1c-1-0.7-2.4-1-3.9-1-2.4 0-4 1.2-4 3.1 0 1.6 1.2 2.5 3.3 2.8l1 0.1c1.1 0.2 1.7 0.5 1.7 1 0 0.7-0.8 1.2-2.2 1.2s-2.5-0.5-3.2-1l-1 1.6c1.1 0.8 2.6 1.2 4.1 1.2 2.8 0 4.4-1.3 4.4-3.1 0-1.7-1.3-2.6-3.3-2.9l-1-0.1c-0.9-0.1-1.6-0.3-1.6-0.9 0-0.7 0.7-1.1 1.8-1.1 1.2 0 2.4 0.5 3 0.8zm55.8-1c-1.2 0-2 0.6-2.5 1.4v-1.2h-2.1v9.6h2.1v-5.4c0-1.6 0.7-2.5 2-2.5 0.4 0 0.9 0.1 1.3 0.2l0.6-2c-0.4-0.1-1-0.1-1.4-0.1zm-26.8 5c0 2.9 2 5 5.1 5 1.4 0 2.4-0.3 3.4-1.1l-1-1.7c-0.8 0.6-1.6 0.9-2.5 0.9-1.7 0-2.9-1.2-2.9-3.1 0-1.8 1.2-3 2.9-3.1 0.9 0 1.7 0.3 2.5 0.9l1-1.7c-1-0.8-2-1.1-3.4-1.1-3.1 0-5.1 2.1-5.1 5zm19.4 0v-4.8h-2.1v1.2c-0.7-0.9-1.7-1.4-3-1.4-2.7 0-4.8 2.1-4.8 5s2.1 5 4.8 5c1.4 0 2.4-0.5 3-1.4v1.2h2.1zm-7.7 0c0-1.7 1.1-3.1 2.9-3.1 1.7 0 2.9 1.3 2.9 3.1 0 1.7-1.2 3.1-2.9 3.1-1.8-0.1-2.9-1.4-2.9-3.1zm-25.1-5c-2.8 0-4.8 2-4.8 5s2 5 4.9 5c1.4 0 2.8-0.4 3.9-1.3l-1-1.5c-0.8 0.6-1.8 1-2.8 1-1.3 0-2.6-0.6-2.9-2.3h7.1v-0.8c0.1-3.1-1.7-5.1-4.4-5.1zm0 1.8c1.3 0 2.2 0.8 2.4 2.3h-5c0.2-1.3 1.1-2.3 2.6-2.3zm52.1 3.2v-8.6h-2.1v5c-0.7-0.9-1.7-1.4-3-1.4-2.7 0-4.8 2.1-4.8 5s2.1 5 4.8 5c1.4 0 2.4-0.5 3-1.4v1.2h2.1zm-7.7 0c0-1.7 1.1-3.1 2.9-3.1 1.7 0 2.9 1.3 2.9 3.1 0 1.7-1.2 3.1-2.9 3.1-1.8-0.1-2.9-1.4-2.9-3.1zm-70.2 0v-4.8h-2.1v1.2c-0.7-0.9-1.7-1.4-3-1.4-2.7 0-4.8 2.1-4.8 5s2.1 5 4.8 5c1.4 0 2.4-0.5 3-1.4v1.2h2.1zm-7.8 0c0-1.7 1.1-3.1 2.9-3.1 1.7 0 2.9 1.3 2.9 3.1 0 1.7-1.2 3.1-2.9 3.1-1.8-0.1-2.9-1.4-2.9-3.1z"
}));
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.21477 0 0 .21477 -99.314 -111.17)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(2.5579 0 0 2.5579 884.9 -11.427)"
  }, _ref2, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_328_",
    transform: "translate(-502.86 -41.014)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st1",
    x: 380.2,
    y: 268.6,
    width: 31.5,
    height: 56.6,
    style: {
      fill: "#ff5f00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_330_",
    className: "st2",
    d: "m382.2 296.9c0-11.5 5.4-21.7 13.7-28.3-6.1-4.8-13.8-7.7-22.2-7.7-19.9 0-36 16.1-36 36s16.1 36 36 36c8.4 0 16.1-2.9 22.2-7.7-8.3-6.5-13.7-16.8-13.7-28.3z",
    style: {
      fill: "#eb001b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "m454.2 296.9c0 19.9-16.1 36-36 36-8.4 0-16.1-2.9-22.2-7.7 8.4-6.6 13.7-16.8 13.7-28.3s-5.4-21.7-13.7-28.3c6.1-4.8 13.8-7.7 22.2-7.7 19.9 0 36 16.2 36 36z",
    style: {
      fill: "#f79e1b"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.b053eb15.svg";
export { ForwardRef as ReactComponent };